import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  FAButton: {
    position: 'fixed',
    bottom: '3%',
    right: '3%',
  },
});
